<main>
  <section class="bg-shape-pageNotFound d-flex h100-vh align-items-center" id="pageNotFound">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-12">
          <h1 class="color-primary">{{'common.error500' | translate}}</h1>
          <h3 class="color-primary">{{'common.error500Titulo' | translate}}</h3>
          <p class="fw-700 fs-20px mt-4 mb-0">{{'common.error500Descricao1' | translate}}</p>
          <p class="fs-20px">{{'common.error500Descricao2' | translate}}</p>
          <button title="Botão Reload" class="btn-custom btn-3 my-3 mx-3" (click)="reload()"><span><p class="my-auto fw-600">{{'common.error500Botao' | translate}}</p><i class="uil uil-arrow-up-right ms-2 color-white"></i></span></button>
          <button title="Botão ir para início" class="btn-custom btn-3 my-3 mx-3" [routerLink]="'/'"><span><p class="my-auto fw-600">{{page404Info.Botao}}</p><i class="uil uil-arrow-up-right ms-2 color-white"></i></span></button>
        </div>
      </div>
    </div>
  </section>
</main>

